import { fetch } from '@/utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryGoodsSeriess(
  {
    page, size, direction, sort,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-series`,
    method: 'get',
    params: {
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryGoodsSeries(goodsSeriesId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-series/${goodsSeriesId}`,
    method: 'get',
  });
}

/**
 * 新增
 * @param  name
 * @param  coverPath
 * @param  nameEn
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addGoodsSeries(
  {
    name,
    coverPath,
    nameEn,
    description,
    isVip,
    descriptionEn,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-series`,
    method: 'post',
    data: {
      name,
      coverPath,
      nameEn,
      description,
      isVip,
      descriptionEn,
    },
  });
}

/**
 * 更新
 * @param goodsSeriesId
 * @param  name
 * @param  coverPath
 * @param  nameEn
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateGoodsSeries(goodsSeriesId, {
  name,
  coverPath,
  nameEn,
  description,
  isVip,
  descriptionEn,
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-series/${goodsSeriesId}`,
    method: 'patch',
    data: {
      name,
      coverPath,
      nameEn,
      description,
      isVip,
      descriptionEn,
    },
  });
}

/**
 * 删除
 * @param goodsSeriesId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteGoodsSeries(goodsSeriesId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-series/${goodsSeriesId}`,
    method: 'delete',
  });
}

/**
 * 上移
 * @param goodsSeriesId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _upGoodsSeries(goodsSeriesId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-series/${goodsSeriesId}/up`,
    method: 'patch',
  });
}

/**
 * 下移
 * @param goodsSeriesId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _downGoodsSeries(goodsSeriesId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-series/${goodsSeriesId}/down`,
    method: 'patch',
  });
}
/**
 * 查询系列下的商品
 */
export function _queryGoodsSeriesGoods(
  {
    id, page, size, direction, sort,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/series-goods`,
    method: 'get',
    params: {
      id,
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 上移
 */
export function _upGoodsSeriesGoods(goodsSeriesId, goodsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-series/${goodsSeriesId}/${goodsId}/goods/up`,
    method: 'patch',
  });
}

/**
 * 下移
 */
export function _downGoodsSeriesGoods(goodsSeriesId, goodsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-series/${goodsSeriesId}/${goodsId}/goods/down`,
    method: 'patch',
  });
}

/**
 * 推荐系列下的商品
 */
export function _recommendSeriesGoods(goodsSeriesId, goodsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-series/${goodsSeriesId}/${goodsId}/recommend`,
    method: 'patch',
  });
}

/**
 * 取消推荐
 */
export function _cancelRecommendGoods(goodsSeriesId, goodsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-series/${goodsSeriesId}/${goodsId}/cancel`,
    method: 'patch',
  });
}

export function _queryCategoryBySeriesId(goodsSeriesId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods-series/${goodsSeriesId}/category`,
    method: 'get',
  });
}

export default {};
